export default function Passeio() {
    return (
        <a href="https://paisagemgrafica.joytill.com.br/passeiovirtual/" target="_blank" className="passeio">
            <img src="/man.svg"></img>
            <span>Passeio Virtual</span>
        </a>
    );
}
